import React, { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import { api, downloadPaidUrl } from "@/lib/api";
import { CheckCircle2, Download, XCircle } from "lucide-react";

export function PaymentSuccess() {
  const [params] = useSearchParams();
  const session_id = params.get("session_id");
  const [status, setStatus] = useState("polling");
  const [tries, setTries] = useState(0);

  useEffect(() => {
    if (!session_id) return;
    let stop = false;
    const poll = async () => {
      try {
        const res = await api.get(`/payments/status/${session_id}`);
        if (res.data.payment_status === "paid") { setStatus("paid"); return; }
        if (["failed", "expired"].includes(res.data.payment_status)) { setStatus("failed"); return; }
      } catch {}
      if (!stop && tries < 20) {
        setTimeout(() => setTries((t) => t + 1), 2000);
      } else if (!stop) setStatus("timeout");
    };
    poll();
    return () => { stop = true; };
  }, [session_id, tries]);

  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="max-w-md w-full text-center bg-[#111116] border border-white/5 rounded-2xl p-10">
        {status === "paid" ? (
          <>
            <CheckCircle2 className="w-16 h-16 text-emerald-500 mx-auto mb-4" />
            <h1 className="font-display font-black text-3xl mb-2 uppercase">¡Pago confirmado!</h1>
            <p className="text-white/60 mb-6">Ya puedes descargar tu música.</p>
            <a
              href={downloadPaidUrl(session_id)}
              data-testid="payment-download-button"
              className="inline-flex items-center gap-2 btn-red text-white px-6 py-3 rounded-full font-semibold"
            >
              <Download className="w-4 h-4" /> Descargar
            </a>
          </>
        ) : status === "failed" ? (
          <>
            <XCircle className="w-16 h-16 text-red-500 mx-auto mb-4" />
            <h1 className="font-display font-black text-3xl mb-2">Pago fallido</h1>
            <Link to="/" className="text-red-500 hover:underline">Volver al inicio</Link>
          </>
        ) : (
          <>
            <div className="animate-spin w-10 h-10 border-2 border-red-600 border-t-transparent rounded-full mx-auto mb-4"></div>
            <p className="text-white/60">Verificando pago...</p>
          </>
        )}
      </div>
    </div>
  );
}

export function PaymentCancel() {
  return (
    <div className="min-h-[70vh] flex items-center justify-center px-5">
      <div className="max-w-md w-full text-center bg-[#111116] border border-white/5 rounded-2xl p-10">
        <XCircle className="w-16 h-16 text-white/40 mx-auto mb-4" />
        <h1 className="font-display font-black text-3xl mb-2">Pago cancelado</h1>
        <Link to="/" className="text-red-500 hover:underline">Volver al inicio</Link>
      </div>
    </div>
  );
}
